import { render, staticRenderFns } from "./SearchNav.vue?vue&type=template&id=47df80a1&scoped=true&"
import script from "./SearchNav.vue?vue&type=script&lang=js&"
export * from "./SearchNav.vue?vue&type=script&lang=js&"
import style0 from "./SearchNav.vue?vue&type=style&index=0&id=47df80a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df80a1",
  null
  
)

export default component.exports